<template>
	<main class="h-screen overflow-y-auto bg-white p-4">
		<PreQuiz
			:jsonData="emptyQuizData"
			:overrideURL="sourceUrl"
			:selectedLanguage="selectedLanguage"
			@close="closeFrame"
		/>
	</main>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import PreQuiz from '@/components/PreQuiz.vue'
import type { LanguageCodes, QuizQuestionsItem } from '@/types'

type PreQuizFrameData = {
	preQuiz: {
		questions: QuizQuestionsItem[]
	}
	_links: {
		preQuiz: {
			href: string
		}
		preQuizEdit: {
			href: string
		}
	}
}

const props = defineProps<{
	sourceUrl?: string | string[]
	lng?: string | string[]
}>()

const sourceUrl = computed(() => {
	const value = Array.isArray(props.sourceUrl) ? props.sourceUrl[0] : props.sourceUrl
	return String(value ?? '').trim()
})

const selectedLanguage = computed(() => {
	const value = Array.isArray(props.lng) ? props.lng[0] : props.lng
	return String(value || 'de') as LanguageCodes
})

const emptyQuizData = computed<PreQuizFrameData>(() => ({
	preQuiz: {
		questions: []
	},
	_links: {
		preQuiz: {
			href: sourceUrl.value
		},
		preQuizEdit: {
			href: sourceUrl.value
		}
	}
}))

const closeFrame = () => {
	window.parent?.postMessage({ action: 'close-and-refresh' }, '*')
}
</script>
